import type {
  InterventionsBatchUpdateDataPayload,
  InterventionsBatchUpdateVariables,
} from "./interventions.type";
import type { InterventionLite } from "@/entities/intervention";
import type { UseBatchOptions } from "@/hooks/queries";

import { useBatch } from "@/hooks/queries";

export const useInterventionsBatchUpdate = (
  interventions: InterventionLite[],
  options?: UseBatchOptions
) => {
  const { mutate: mutateFn, ...mutationResult } =
    useBatch<InterventionsBatchUpdateVariables>(
      "interventions",
      "update",
      options
    );

  const mutate = (value: InterventionsBatchUpdateDataPayload) => {
    const ids = interventions.map((a) => a.id);
    mutateFn({ interventions: ids, ...value });
  };

  return {
    ...mutationResult,
    mutate,
  };
};
